<template>
  <v-container fluid ref="Dialog" class="DataTableMaka">
    <TankItemComponent />
    <TankTableComponent />
  </v-container>
</template>

<script>
// @ is an alias to /src
import { serverBus } from "../main";

import TankItemComponent from "@/components/TankItemComponent.vue";
import TankTableComponent from "@/components/TankTableComponent.vue";

export default {
  name: "tank",
  components: {
    TankItemComponent,
    TankTableComponent
  },
  methods: {
  scrollToTop () {
    this.$el.scrollTop = 0
  }
},
mounted() {
  serverBus.$on("scroll_to_top", () => {
      // alert(idRoom);
      

      // console.log(document.getElementById("Dialog"))
      document.getElementById("Dialog").scrollTop = 0;

    })
}
};
</script>
           
<style scoped lang='scss'>
</style>
